import type { GetGroupResGroupObjectType } from "@whatslly/types/chat-groups/res/GetGroupResponse";
import React from "react";
import styles from "../ChatGroup.module.scss";
import { GlobalSearchItem } from "@whatslly/ui-components/GlobalSearchItem";
import upperFirst from "lodash/upperFirst";
import { getPersonType } from "@whatslly/types/Person";
import { useTranslation } from "react-i18next";
import { getPersonTypeText } from "@whatslly/commons/personPageUtils";
import { observer } from "mobx-react-lite";
import type { ChatMessageCrm } from "../../../../ChatComponent/types/ChatMessageCrm";

export const Participants: React.FC<{
  members?: GetGroupResGroupObjectType["members"];
  loginProvider?: ChatMessageCrm;
  baseUrl?: string;
  menuItemNameSize?: "medium" | "small";
}> = observer(({ members, baseUrl, loginProvider, menuItemNameSize }) => {
  const { t } = useTranslation();

  if (!members || members.length === 0) {
    return (
      <div className={styles.noParticipantsContainer}>
        <div>{t("chat_groups.no_records_found")}</div>
        <div className={styles.noParticipantsText}>{t("chat_groups.open_group_panel_to_link")}</div>
      </div>
    );
  }

  return (
    <>
      {members.map((member, i) => (
        <div data-testid={`groups-participants-item`} className={styles.participantWrapper} key={`${member.phone}_${i}`}>
          <GlobalSearchItem
            menuItemNameSize={menuItemNameSize}
            name={member.name}
            phones={[{ label: `Phone`, name: `Phone`, value: member.phone }]}
            companyName={member.companyNameOrAccountName}
            type={getPersonType({ type: upperFirst(member.type) })}
            id={member.id || ""}
            typeText={getPersonTypeText(getPersonType({ type: upperFirst(member.type) }), t)}
            baseUrl={baseUrl}
            hideCrmLinks={false}
            loginProvider={loginProvider}
            wrapperClassName={styles.participantWrapper}
            viewInCrmTarget={`_blank`}
          />
        </div>
      ))}
    </>
  );
});
